export type NumberDrillthroughParams = {
  staffProfileId: string | null;
  phoneNumber: string | null;
};

export function readNumberDrillthroughParams(params: URLSearchParams): NumberDrillthroughParams {
  return {
    staffProfileId: cleanParam(params.get('staffProfileId')),
    phoneNumber: cleanParam(params.get('phoneNumber')),
  };
}

export function hasNumberDrillthrough(params: NumberDrillthroughParams): boolean {
  return Boolean(params.staffProfileId || params.phoneNumber);
}

export function matchesStaffProfileId(rowStaffProfileId: string | null | undefined, staffProfileId: string | null): boolean {
  return !staffProfileId || rowStaffProfileId === staffProfileId;
}

export function matchesPhoneNumber(rowPhoneNumber: string, phoneNumber: string | null): boolean {
  return !phoneNumber || rowPhoneNumber === phoneNumber;
}

export function buildNumbersDrillthroughUrl(params: { staffProfileId: string; phoneNumber?: string | null }): string {
  const search = new URLSearchParams({ staffProfileId: params.staffProfileId });
  if (params.phoneNumber) search.set('phoneNumber', params.phoneNumber);
  return `/numbers?${search.toString()}`;
}

function cleanParam(value: string | null): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}
